import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
// import bgImage from "../images/Individual leaderboard.png";
function MyRank(btnRef) {
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	const items = [];
	const items2 = [];
	// const prevScrollY = useRef(0);
	let history = useHistory();
	const [isEnableImpactPlayerBtn, setIsEnableImpactPlayerBtn] = useState({marginTop:"5%", border:"1px solid #fff"});
	const [leaderboardStyle, setleaderboardStyle] = useState({overflowY:"scroll", height:"50vh"});
	useEffect(() => {
		localStorage.setItem("loader", "free");
		const fetchData = async () => {
			try {
			  const requestOptions = {
				method: "POST",
				headers: {
				  "Content-Type": "application/json",
				  token: token,
				  userId: user_id,
				},
				body: JSON.stringify({ dist_user_id: user_id }),
			  };
			  const response = await fetch(
				process.env.REACT_APP_BKB_URL_DOMAIN +
				  "get-impact-warrior-leaderboard",
				requestOptions
			  );
			  const data = await response.json();
			  console.log("API Impact Warrior Response from my rank:", data);
			  if (data.hasOwnProperty('self')) {
				  let selfPoints = data.self.points;
				  selfPoints = selfPoints.replace(/,/g, ''); // Remove comma using regular expression
				  selfPoints = parseInt(selfPoints);
				  console.log('self points', selfPoints);
				//   selfPoints = 0;
				if (selfPoints <= 0) {
					setIsEnableImpactPlayerBtn(
						{marginTop:"5%", border:"1px solid #fff", display : "none"}
					)
					setleaderboardStyle(
						{overflowY:"scroll", height:"60vh"}
					)
				}
			  }
			} catch (error) {
			  console.error("Error fetching data:", error);
			}
		  };
	  
		fetchData();
		getLeaderboardData();
	}, []);
	const [leaderData, setLeaderData] = useState({"status":"failuer","self":{"dist_user_id": "","rank": "NA","points": 0,"name": "","city": "","profile_pic": ""},"leaders":[]});
	const [error1, setError] = useState(false);
	const [seasonAward, setSeasonAward] = useState('');
	const [leaders, setLeaders] = useState([]);
	const [finalLeaders, setFinalLeaders] = useState([]);
	const [startRank, setStartRank] = useState(1);
	const [endRank, setEndRank] = useState(10);

	const prevScrollY = useRef(0);
  	const [goingUp, setGoingUp] = useState(false);
	
	const onScroll = (e) => {
		console.log("here");
		const currentScrollY = e.target.scrollTop;
		if (prevScrollY.current < currentScrollY && goingUp) {
			setGoingUp(false);
		}
		if (prevScrollY.current > currentScrollY && !goingUp) {
			setGoingUp(true);
		}
		prevScrollY.current = currentScrollY;
		console.log(currentScrollY);
		console.log(e.target.scrollHeight);

		if (Math.ceil(window.innerHeight +currentScrollY) > e.target.scrollHeight) {
			// Do load more content here!
			console.log("bottom");
			loadMore("down")
		}
		if(currentScrollY === 0){
			console.log("top");
			loadMore("up")
		}
	};

	async function loadMore(params){
		if(localStorage.getItem("loader") === "free"){
			localStorage.setItem("loader", "loading");
		if(params === "down"){
			let s = endRank + 1;
			let e = endRank + 100;
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
				body: JSON.stringify({dist_user_id:user_id,start_rank:s,end_rank:e}),	
			};
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				setError(true);
			}
			for (const [index, value] of data.leaders.entries()) {
				let pp = '';
				if(value.profile_pic === 'NA' || value.profile_pic === ''){
					pp = require("./../images/defaultProfile.png").default;
				} else {
					pp = value.profile_pic;
				}
				let row = await getHtml(value);
				items.push(row);
		 	}
			// setLeaders(leaders.concat(items));
			await addMilestoneCards(leaders.concat(items));
			// console.log(leaders);
			setEndRank(data.end_rank);
		}
		if(params === "up"){
			let s = startRank - 100;
			if(s <= 0){
				s= 1;
			}
			let e = startRank - 1;
			const requestOptions = {
				method: 'POST',
				headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
				body: JSON.stringify({dist_user_id:user_id,start_rank:s,end_rank:e,order:"desc"}),	
			};
			const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
			const data = await response.json();
			if (data.status !== "success"){
				setError(true);
			}
			//var new_items = [];
			for (const [index, value] of data.leaders.entries()) {
				let pp = '';
				if(value.profile_pic === 'NA' || value.profile_pic === ''){
					pp = require("./../images/defaultProfile.png").default;
				} else {
					pp = value.profile_pic;
				}
				let row = await getHtml(value);
				leaders.unshift(row);
		  	}
			await addMilestoneCards(leaders.concat(items));
			// setLeaders(items.concat(leaders));
			// console.log(leaders);
			setStartRank(data.start_rank);
		}
			localStorage.setItem("loader", "free");
		}
	}
	const getLeaderboardData = async () => {
		
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({dist_user_id:user_id}),
			
		};
		localStorage.setItem("milestone", JSON.stringify({"l1":"","l5":"","l10":"","l25":""}));
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-leaderboard', requestOptions);
		const data = await response.json();
		if (data.status !== "success"){
			setError(true);
		}

		
		const self_rank_index = data.self_rank_index;
		const myRankData = [];
		const before_self_rank_index = self_rank_index === 0 ? self_rank_index : self_rank_index - 1;
		
		for (let i = before_self_rank_index; i <= self_rank_index + 1; i++) {
			if (i in data.leaders) {
				myRankData.push(data.leaders[i]);
			}
		}
		for (const [index, value] of myRankData.entries()) {
			let pp = '';
			if(value.profile_pic === 'NA' || value.profile_pic === ''){
				pp = require("./../images/defaultProfile.png").default;
			} else {
				pp = value.profile_pic;
			}
			let row = await getHtml(value, data.self.dist_user_id);
			localStorage.setItem("selfPoints", data.self.points);
			localStorage.setItem("selfRank" , data.self.rank);
			let currentPoints = value.points;
			items.push(row);
		}
		// console.log(items);
		// delete items[49];
		// setLeaders(items);
		await addMilestoneCards(items);
		setSeasonAward(data.season_data.banner);
		setLeaderData(data);
		setStartRank(data.start_rank);
		setEndRank(data.end_rank);
	};

	async function addMilestoneCards(lead){
		// setLeaders(lead);
		
		console.log(lead.length);
		let i = 0;
		let l1 = '';
		let l5 = '';
		let l10 = '';
		let l25 = '';
		let selfPoints = localStorage.getItem("selfPoints");
		selfPoints = selfPoints.replaceAll(',','');
		// selfPoints = 2510000;
		let achievedHtml = '';
		if(selfPoints >= 2500000){
			l10 = 'done';
			l5 = 'done';
			l1 = 'done';
			l25 = 'done';
			let achievedimg = require("./../images/10-gm-achieved.svg").default;
			achievedHtml = <div key="25l" className="row row-mrg-override">
				<div className="w-100 mrg-10 top-rank">
					<img src={achievedimg} alt="back" className="img-fluid" />
				</div>
			</div>
		} else if(selfPoints < 2500000 && selfPoints >= 1000000) {
			l5 = 'done';
			l1 = 'done';
			l10 = 'done';
			let achievedimg = require("./../images/5-gm-achieved.svg").default;
			achievedHtml = <div key="10l" className="row row-mrg-override">
				<div className="w-100 mrg-10 top-rank">
					<img src={achievedimg} alt="back" className="img-fluid" />
				</div>
			</div>
		} else if(selfPoints < 1000000 && selfPoints >= 500000) {
			l1 = 'done';
			l5 = 'done';
			let achievedimg = require("./../images/10k-achieved.svg").default;
			achievedHtml = <div key="5l" className="row row-mrg-override">
				<div className="w-100 mrg-10 top-rank">
					<img src={achievedimg} alt="back" className="img-fluid" />
				</div>
			</div>
		} else if(selfPoints < 500000 && selfPoints >= 100000) {
			l1 = 'done';
			let achievedimg = require("./../images/3k-achieved.svg").default;
			achievedHtml = <div key="1l" className="row row-mrg-override">
				<div className="w-100 mrg-10 top-rank">
					<img src={achievedimg} alt="back" className="img-fluid" />
				</div>
			</div>
		}

		//unachieved html
		if(l1 === '' && selfPoints < 100000){
			let unachievedimg = require("./../images/3k-unachieved.svg").default;
			items2.push(
				<div key="1l" className="row row-mrg-override">
					<div className="w-100 mrg-10 top-rank">
						<img src={unachievedimg} alt="back" className="img-fluid" />
					</div>
				</div>
			);
			// setLeaders(items.concat(leaders));
		} else if(l5 === '' && selfPoints < 500000){
			let unachievedimg = require("./../images/10k-unachieved.svg").default;
			items2.push(
				<div key="5l" className="row row-mrg-override">
					<div className="w-100 mrg-10 top-rank">
						<img src={unachievedimg} alt="back" className="img-fluid" />
					</div>
				</div>
			);
			// setLeaders(items.concat(leaders));
		} else if(l10 === '' && selfPoints < 1000000){
			let unachievedimg = require("./../images/5-gm-unachieved.svg").default;
			items2.push(
				<div key="10l" className="row row-mrg-override">
					<div className="w-100 mrg-10 top-rank">
						<img src={unachievedimg} alt="back" className="img-fluid" />
					</div>
				</div>
			);
			// setLeaders(items.concat(leaders));
		} else if(l25 === '' && selfPoints < 2500000){
			let unachievedimg = require("./../images/10-gm-unachieved.png").default;
			items2.push(
				<div key="25l" className="row row-mrg-override">
					<div className="w-100 mrg-10 top-rank">
						<img src={unachievedimg} alt="back" className="img-fluid" />
					</div>
				</div>
			);
			// setLeaders(items.concat(leaders));
		}
		for (;i<lead.length;i++) {
			items2.push(lead[i]);
		}

		items2.push(achievedHtml);
		setLeaders(items2);
		
	}

	async function getHtml(value, distUserId=''){
		let html = '';
		let a = JSON.parse(localStorage.getItem("milestone"));
		let num_font_sz = "";
		let selfRank = localStorage.getItem("selfRank");
		// localStorage.setItem("milestone",JSON.stringify((a)));
		console.log('value.city');
		console.log(value.name);
		let selfPoints = localStorage.getItem("selfPoints");
		if(selfPoints === null){
			selfPoints = 0;
		}else {
			selfPoints = selfPoints.replaceAll(',','');
		}
		if(value.dist_user_id == distUserId ) {
			num_font_sz = "num-font-sz-large";
			if (value.rank > '99') {
				num_font_sz = "num-font-sz-small";
			}
			let bgStyle = {
				backgroundImage : `url(${require("../images/Individual_leaderboard.png").default})`
			}
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override margin-cont">
				<div className="w-15 position-relative vcenter">
					<div className="numWhtImgCont">
						<div className={`numImg ${num_font_sz} vcenter2`}>{value.rank}</div>
					</div>
				</div>
				<div className="w-80  col-bluver bg-wht flt-lft pad-tb5-lr10" style={bgStyle}>
					<div className="w-65 flt-lft top-data">
						<div className="top-title">{value.name}</div>
						<div className="top-shop">{value.city}</div>
						<div className="top-shop">{value.company_name}</div>
					</div>
					<div className="w-35 txt-rgt top-points top-points-2">
						<span className="top-points-val">{value.points}</span>
						<span className="top-points-img"><img style={{backgroundColor : "#fff", borderRadius : "50%"}} src={require("./../images/pay-point-icon.svg").default} alt="point-icon" className="img-fluid"/></span>
					</div>
				</div>
			</div>;
		} else {
			num_font_sz = "num-font-sz-large";
			if (value.rank > '99') {
				num_font_sz = "num-font-sz-small";
			}
			
			html = 
			<div key={value.dist_user_id+"-"+value.points} className="row row-mrg-override margin-cont">
				<div className="w-15 position-relative vcenter">
					<div className="numWhtImgCont">
						<div className={`numImg ${num_font_sz} vcenter2`}>{value.rank}</div>
					</div>
				</div>
				<div className="w-80 col-bluver bg-wht flt-lft pad-tb5-lr10">
					<div className="w-65 flt-lft top-data">
						<div className="top-title">{value.name}</div>
						<div className="top-shop">{value.city}</div>
						<div className="top-shop">{value.company_name}</div>
					</div>
					<div className="w-35 txt-rgt top-points top-points-2">
						<span className="top-points-val">{value.points}</span>
						<span className="top-points-img"><img style={{backgroundColor : "#fff", borderRadius : "50%"}} src={require("./../images/pay1-points-img.svg").default} alt="point-icon" className="img-fluid"/></span>
					</div>
				</div>
			</div>;
		}
		return html;
	}

	const IPModalClick = () => {
		console.log('IPModalClick');
		console.log(btnRef.btnRef)
		if (btnRef.btnRef.current) {
			console.log('IPModalClick1');
			console.log(btnRef.btnRef.current)
            btnRef.btnRef.current.click();
        }
	}
	// let IPRankModalRef = useRef(null);
	// let IPRankModalBtnRef = useRef(null);
	return (
<>
	{/* <HelmetProvider> */}
		<Helmet link={
			[{"rel": "stylesheet", "href": 'css/leaderboard.css'}]
		}/>
	{/* </HelmetProvider> */}
	<div className="row no-gutters">
		{ error1 === false && (
		<div className="application">
            
			<div className="leaderboard-section-2" id="bg-grey-rank" style={leaderboardStyle}>
				{leaders}
			</div>
			<a data-toggle="modal" data-target="#ip_rank_modal" className='btn btn-default text-white' style={isEnableImpactPlayerBtn} onClick={()=>IPModalClick()}>View Impact Player Rank</a>
    	</div>
		)}
		{ error1 === true && (
			<Redirect to='/'  />
		)}
		<div className="bg"></div>
		
	</div>
</>
	);
}

export default MyRank;
